module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css",
      "integrity": "sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "name": "viewport",
      "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " col-md-6 col-12 p-0"
  }, [_c('div', {
    staticClass: "col-12 row mx-0 px-3 py-2",
    staticStyle: {
      "background-image": "linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123))",
      "color": "#ffffff"
    }
  }, [_c('h3', [_c('strong', [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][1]))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'my-kh',
        params: {
          language: _vm.$route.params.language
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "font-size": "15px",
      "border-radius": "5px"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][0]))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][2]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "180px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.targetKH),
      expression: "targetKH"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "4",
      "size": "3",
      "name": "TargetTankKH",
      "type": "text"
    },
    domProps: {
      "value": (_vm.targetKH)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.targetKH = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v("dKH")])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 py-2"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][3]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][4]) + " " + _vm._s(_vm.msglist[_vm.$route.params.language][6]))]), _vm._v(" "), _c('div', {
    staticClass: "px-2 row align-self-center",
    staticStyle: {
      "width": "180px"
    }
  }, [_c('span', {
    staticClass: "col-auto px-2 align-self-center",
    staticStyle: {
      "font-size": "1.2rem",
      "font-weight": "bold"
    }
  }, [_vm._v("+-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.KHspec),
      expression: "KHspec"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "3",
      "name": "KH_specification",
      "type": "text"
    },
    domProps: {
      "value": (_vm.KHspec)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.KHspec = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v("dKH")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][7]))]), _vm._v(" "), _c('div', {
    staticClass: "px-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "180px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeHr),
      expression: "timeHr"
    }],
    staticClass: "col form-control",
    staticStyle: {
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "name": "Timer_value"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeHr = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1",
      "selected": "selected"
    }
  }, [_vm._v("1 " + _vm._s(_vm.msglist[_vm.$route.params.language][14]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4  ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6  ")])]), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][8]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 py-2"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][9]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][10]))]), _vm._v(" "), _c('div', {
    staticClass: "px-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "180px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sleep_start),
      expression: "sleep_start"
    }],
    staticClass: "col form-control",
    staticStyle: {
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "name": "Sleep_start_value"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sleep_start = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "selected": "selected"
    }
  }, [_vm._v("0" + _vm._s(_vm.msglist[_vm.$route.params.language][14]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("13")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("14")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("16")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17"
    }
  }, [_vm._v("17")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18"
    }
  }, [_vm._v("18")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "19"
    }
  }, [_vm._v("19")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("21")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "22"
    }
  }, [_vm._v("22")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "23"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v(" - ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sleep_end),
      expression: "sleep_end"
    }],
    staticClass: "col form-control",
    staticStyle: {
      "font-size": "1.2rem",
      "font-weight": "bold"
    },
    attrs: {
      "name": "Sleep_end_value"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sleep_end = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "selected": "selected"
    }
  }, [_vm._v("0" + _vm._s(_vm.msglist[_vm.$route.params.language][14]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("13")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("14")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("15")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "16"
    }
  }, [_vm._v("16")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "17"
    }
  }, [_vm._v("17")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18"
    }
  }, [_vm._v("18")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "19"
    }
  }, [_vm._v("19")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("21")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "22"
    }
  }, [_vm._v("22")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "23"
    }
  }, [_vm._v("23")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-3 mb-1 justify-content-center",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [(_vm.name !== 'khacra') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "name": "KH_settings_button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][11]))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1 justify-content-center"
  }, [_c('div', {
    staticClass: "col-12 px-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][12]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 mt-3"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][13]))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,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"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,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"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEBklEQVR4nO2ZzWuVRxTGf2JMIurCRBShK5tCMTVJU1NQ1CpIoSsXSv4DCXbjptta40baqteNxez8gIpCEj8Q/wipiqZ+gQtxpUalFluT6I0ceAYOd9E7c995b5LiAy/c+87MmfeZ8zFnzsBH/D/wCXAMGGKBYhlwGJgCZoEHLEDsAB6LwHvgd6DHtbepzzAwDtwFXgLTIm6//1Sb9dmuMU3DIuAn4J1IXAcGXHs/MAK8UnvKY2NOAl+WTWIJcNZpwVZysdr6gGs1H3YDOALskbZWSsYS/e5R21HgphtXBa7WaDgricua6DXwrd4vBSpOQ9b2C/B5A3PYmF8lw2TNiGR7TnMKmngGfKX3nwG39H5aq28rXRQdioIzkm3a6soglwNutQOJr4Hnem+O3Et+9AH33AJ6X0zGDpnNe2dORuJvTTCuMByL4AexWA5cdAvZEJllLsSaYwdzCpo45Zy9LCKGFuC008ynJOKwC7GL5di3nCZSSTRKJJC55KJhe0raMSWTCuqsOJ9IMaccRIKZ3dd4CyxROKYB55zjzegp4thFiKDNMnzHBiIwpNwpbErXUleiJCLeMq6QiH4N/CvDPpGDSIciWFWWEo0RTW67LvOACLIMk/MbkWhzCWAjaUdZRNZLzgugNXZDDCGPeUTEcFuythGB4UxOXgaRimTZsaIuQnpg6fZ8IzIoWWMxne+qc1TMbjKRXsmaiOk8qc4W8opipyNiv4tilWRZ7lcXobAQFRnq4JEjYr+Lok2y3jabyBNHxA5iq5tJZFKdOymO70RmWjLvFCSzKsW0cjs7+viJDGR6U5x9PHP4zUlmUONH52JDzEmmorFWU6iL7a6SUQZWi0QjZO5o3NbYyPAyY9JYj8z3kWO61X9SNbconMyYxv8XmX0J/Y+mpvHheFnVYSbHDl8UnSpHVd2x24qIUbiqFbCz/FzjuL7FSrhhoR8Ce2MG97hDf9LxMjP69Q22qX6hd2Opph/s8p5KM83GChVEZlUoN3wjE3sDrIkV1O7K/xdVNGsWWtxtwB+Kpq1uH/oxVWCXypazKmM2g0wLcEZzPgXW1dTeHjR62zXg7jAulWxmK2ruZTbq/W6Z1JSK6g1jwGnmfknXZf3OJ546EluAf/R+f46JulRdCbdLlUzpfqdC7IzziWBOm12mkbQZxgSAI27S1/pvdadUdCsyhruXaUWnYP+7FJ2s7XyDtwF1sUG12Ko7Bd6Wlga193Qo0rRq1fvUVnG5VrgMNb8wYsHZf3ayR8oi4dEnlb+oueGNeSwBPFFT7d/k7mRM6z/QZLQqvT6og8+EPnRKz6S0MKoC25aaLNbIXHBaeCT/WHAI0epf4JBuyxYk7H7GHH/tXH/IR5ABHwDCcXhp13IQVgAAAABJRU5ErkJggg=="
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEnUlEQVR4nO2aTWgdVRTHf9q0SbVd1JSH4EZRsba2SQPqQtEU3dSNippN3LoQFBGRLkS0C1Fr4tONtjvrRlo/Gr/oQlduBOtHNbEf2gpWrEX7galVm6d9cuA/cJjMvJk7704SoX8YmHc/zj3/ueece+69D87j/4UlwAiwEzgInAVmgMPADuB+YGmEcUzGqGQeAlrAX8AB4A3gPulSCfcAPwDtgudN4IIuSFjft0uMcwi4O0TwhcALTsDXwMPAaqAPGAT+UN1HkWbkIuBjyTwNrJNcG/MRYNLp87x0LMTL6mBm9GCq0yrgaGQSWWR+Bq5xdYuAh6ST1b9YJOxeNTQ/uC1VV0SiF9gAbAZ2AfuAk5J1Vu/fqs7aDKtPWTKG2+U/Vn8XOTBn+kmNHg0gMQRsA06VsPP0Y322AusDyDymuh+BxVlERp1TlTEn85XdKcW+BMY0s2bnKzTYYr2vU9048JXrdw74UPVlzCwJQhZRZ2GnKh8vIGFPE/hH5dPAFrUNxSoFlmnJaolkX4rM0RSZTSq30DwLh1V5cwcSVwN7nR+N6Ut3i0vkwC3Jttm6qgOZW1T2XZawv1V5aQ6JG4DfVGaOPEB8DAL7NcavwPU5ZC7T7zOdiGzMIXFaZRZ1LqY+LAMmnNlmkdmo9z87mdaZDHNKZuI1OVvd6AG2u5m5MkUm0fH7rM47XBTxjr3XzcRckPBk3nXRMB0Acp19NCPENp1P1GlOnczsgHSwwEKKjOk8C9bgrdQ60dLTrWOHLpQe650ea1W2VMlqqRRpd+pLzBcRbxnvE4ghdfw90jpRBMtyj2jMqZx1ZloZgFlKaWyTUFt168ZNwAmN90mHDzemNq+UFdzrEsAqaUcI7tRakETFvoJZa4t0qd3iBhfy6sQDLl97tWRo/0btLUUpxOaITp6Hp5xj23tZNEP6JOmBpduxsUhfv63ZsFkJwYj6vlOm8T41TmJ2LPTJD5IcyfwjFAMdItssHFdjC3mxsEIRKXFWi1RVsFIyLPcrRLLBr3yOlIEpyTyi6FMVvZJjmfq8EOl2Za9EJDGtfhYekZUhplWXs8fAQIiz76ox/HaLEelmR6yFeDpgQaxiHt2gKdlPlmk87E4yFhqRydRJT0f0umw0JGm8wyWbpWw4EGuco2eeMGZha0Aab9cCTwD/Ovu1LWpsjIem8Ul0OKfrAwt5eVimLWdb7Z8re+QfiH63sQqOph+UOMJPVuxTMq268JLGsVOVSjY5o03/4Dw6+5B0MF2urSpki5Tan2P3dRNZrrvLtsy2MiyCfSFBEzo0myv0AO9p7D0xcr8rgGMSuH2OyPQAr2vMX4DLYwlODo0Th6sjvCZY7mairbGjoJG6VW3rGNNfl8V07IOpsSalQzQSFmpvdD7TUu4TI93vV4htSfbnusqYikEmTaLh9t7PukGnlWCurhjix93dSwt4xt32Nrol40nkCbguZcttnTs1lW4Pat+/RE+/ykbUJm2uFhXXVNQlF3sCOq5VbpbsLEOe4+prH6UTPJnPQoh8KjttBIbMYe0VJmQSyR8GZvQ+qY2btbk1MJQ3pJPpdh4sdPwHzhQd7V020iEAAAAASUVORK5CYII="
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1150cb67"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KH_settings.vue
// module id = 512
// module chunks = 0